import React, { useState, useEffect } from "react";
import { Card, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosClient";
import QuizCategoryCard from "./QuizCategoryCard";

// const categories = [
//    { id: 10, name: "Flair AI Robot", path: "/quiz/robot" },
//   { id: 1, name: "Addition & Subtraction", path: "/quiz/math" },
//   { id: 2, name: "Sorting", path: "/quiz/sorting" },
//   { id: 3, name: "Multiplication", path: "/quiz/multiplication" },
//   { id: 4, name: "Logical Questions", path: "/quiz/logic" },
//   { id: 5, name: "Sudoku", path: "/quiz/sudoku" },
//   { id: 6, name: "Puzzles", path: "/quiz/puzzles" },
//    { id: 7, name: "Shapes", path: "/quiz/shapes" },
//   { id: 8, name: "Time", path: "/quiz/time" },
//    { id: 9, name: "Fraction", path: "/quiz/fraction" },
  
// ];
const categories = [
  {
    id: 10,
    name: "Flair AI Robot",
    icon: "🤖",
    color: "linear-gradient(135deg,#FF4D8D,#D81B60)",
    path: "/quiz/robot",
  },
  {
    id: 1,
    name: "Addition & Subtraction",
    icon: "➕",
    color: "linear-gradient(135deg,#22C55E,#16A34A)",
    path: "/quiz/math",
  },
  {
    id: 2,
    name: "Sorting",
    icon: "🧩",
    color: "linear-gradient(135deg,#4FACFE,#00F2FE)",
    path: "/quiz/sorting",
  },
  {
    id: 3,
    name: "Multiplication",
    icon: "✖️",
    color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplication",
  },
  {
    id: 4,
 name: "Pattern",
    icon: "🧠",
    color: "linear-gradient(135deg,#7C4DFF,#5E35B1)",
    path: "/quiz/logic",
  },
  {
    id: 5,
    name: "Sudoku",
    icon: "🔢",
    color: "linear-gradient(135deg,#26C6DA,#00ACC1)",
    path: "/quiz/sudoku",
  },
  {
    id: 6,
    name: "Puzzles",
    icon: "🎯",
    color: "linear-gradient(135deg,#FF5252,#E53935)",
    path: "/quiz/puzzles",
  },
  {
    id: 7,
    name: "Shapes",
    icon: "📐",
    color: "linear-gradient(135deg,#42A5F5,#1E88E5)",
    path: "/quiz/shapes",
  },
  {
    id: 8,
    name: "Time",
    icon: "⏰",
    color: "linear-gradient(135deg,#FFCA28,#FFA000)",
    path: "/quiz/time",
  },
  {
    id: 9,
    name: "Fraction",
    icon: "🍕",
    color: "linear-gradient(135deg,#AB47BC,#8E24AA)",
    path: "/quiz/fraction",
  },
];
// const categories2 = [
//      { id: 14, name: "Flair AI Robot", path: "/quiz/robot" },
//   { id: 1, name: "Addition & Subtraction", path: "/quiz/math" },
//   { id: 2, name: "Large Numbers", path: "/quiz/placevalue" },
//   { id: 3, name: "Sorting", path: "/quiz/sorting" },
//   { id: 4, name: "Multiplication", path: "/quiz/multiplication" },
//   { id: 5, name: "Division", path: "/quiz/division" },
//   { id: 6, name: "Logical Questions", path: "/quiz/logic" },
//   { id: 7, name: "Sudoku", path: "/quiz/sudoku" },
//   { id: 8, name: "Puzzles", path: "/quiz/puzzles" },
//   { id: 9, name: "Money", path: "/quiz/money" },
//   { id: 10, name: "Shapes", path: "/quiz/shapes" },
//   { id: 11, name: "Measurement", path: "/quiz/measure" },
//   { id: 12, name: "Time", path: "/quiz/time" },
//   { id: 13, name: "Fraction", path: "/quiz/fraction" },

// ];
const categories2 = [
  {
    id: 14,
    name: "Flair AI Robot",
    icon: "🤖",
    color: "linear-gradient(135deg,#FF4D8D,#D81B60)",
    path: "/quiz/robot",
  },
  {
    id: 1,
    name: "Addition & Subtraction",
    icon: "➕",
    color: "linear-gradient(135deg,#22C55E,#16A34A)",
    path: "/quiz/math",
  },
  {
    id: 2,
    name: "Large Numbers",
    icon: "🔢",
    color: "linear-gradient(135deg,#4FACFE,#00F2FE)",
    path: "/quiz/placevalue",
  },
  {
    id: 3,
    name: "Sorting",
    icon: "🧩",
    color: "linear-gradient(135deg,#26C6DA,#00ACC1)",
    path: "/quiz/sorting",
  },
  {
    id: 4,
    name: "Multiplication",
    icon: "✖️",
    color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplication",
  },
  {
    id: 5,
    name: "Division",
    icon: "➗",
    color: "linear-gradient(135deg,#F06292,#E91E63)",
    path: "/quiz/division",
  },
   {
    id: 6,
    name: "Puzzles",
    icon: "🧠",
    color: "linear-gradient(135deg,#9C27B0,#673AB7)",
    path: "/quiz/puzzles",
  },
   {
    id: 7,
    name: "Symmetry & Pattern",
    icon: "🦋",
    color: "linear-gradient(135deg,#7C4DFF,#5E35B1)",
    path: "/quiz/logic",
  },
  {
    id: 8,
    name: "Sudoku",
    icon: "🔢",
    color: "linear-gradient(135deg,#00BCD4,#0097A7)",
    path: "/quiz/sudoku",
  },

  {
    id: 9,
    name: "Money",
    icon: "💰",
    color: "linear-gradient(135deg,#FFD54F,#FFB300)",
    path: "/quiz/money",
  },
  {
    id: 10,
    name: "Geometry & Shapes",
    icon: "📐",
    color: "linear-gradient(135deg,#42A5F5,#1E88E5)",
    path: "/quiz/shapes",
  },
  {
    id: 11,
    name: "Measurement",
    icon: "📏",
    color: "linear-gradient(135deg,#66BB6A,#43A047)",
    path: "/quiz/measure",
  },
  {
    id: 12,
    name: "Time",
    icon: "⏰",
    color: "linear-gradient(135deg,#FFA726,#FB8C00)",
    path: "/quiz/time",
  },
  {
    id: 13,
    name: "Fraction",
    icon: "🍕",
    color: "linear-gradient(135deg,#AB47BC,#8E24AA)",
    path: "/quiz/fraction",
  },
    {
    id: 14,
    name: "Multiples & Factors",
    icon: "🧮",
     color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplefactors",
  },
];
const categories3 = [
  {
    id: 4,
    name: "Grade 4 Olympiad",
    icon: "🏆",
    color: "linear-gradient(135deg,#FF9966,#FF5E62)",
    path: "/quiz/grade4",
  },
 
];

const categories4 = [
  
  {
    id: 14,
    name: "Flair AI Robot",
    icon: "🤖",
    color: "linear-gradient(135deg,#FF4D8D,#D81B60)",
    path: "/quiz/robot",
  },
  //   {
  //   id: 15,
  //   name: "Multiples & Factors",
  //   icon: "🧮",
  //     color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
  //   path: "/quiz/multiplefactors",
  // },
   {
    id: 2,
    name: "Large Numbers",
    icon: "🔢",
    color: "linear-gradient(135deg,#4FACFE,#00F2FE)",
    path: "/quiz/placevalue",
  },
  {
    id: 1,
    name: "Addition & Subtraction",
    icon: "➕",
    color: "linear-gradient(135deg,#22C55E,#16A34A)",
    path: "/quiz/math",
  },
 
  {
    id: 3,
    name: "Sorting",
    icon: "🧩",
    color: "linear-gradient(135deg,#26C6DA,#00ACC1)",
    path: "/quiz/sorting",
  },
  {
    id: 4,
    name: "Multiplication",
    icon: "✖️",
    color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplication",
  },
  {
    id: 5,
    name: "Division",
    icon: "➗",
    color: "linear-gradient(135deg,#F06292,#E91E63)",
    path: "/quiz/division",
  },
   {
    id: 6,
    name: "Puzzles",
    icon: "🧠",
    color: "linear-gradient(135deg,#9C27B0,#673AB7)",
    path: "/quiz/puzzles",
  },
   {
    id: 7,
    name: "Symmetry & Pattern",
    icon: "🦋",
    color: "linear-gradient(135deg,#7C4DFF,#5E35B1)",
    path: "/quiz/logic",
  },
  {
    id: 8,
    name: "Sudoku",
    icon: "🔢",
    color: "linear-gradient(135deg,#00BCD4,#0097A7)",
    path: "/quiz/sudoku",
  },

  {
    id: 9,
    name: "Money",
    icon: "💰",
    color: "linear-gradient(135deg,#FFD54F,#FFB300)",
    path: "/quiz/money",
  },
  {
    id: 10,
    name: "Geometry & Shapes",
    icon: "📐",
    color: "linear-gradient(135deg,#42A5F5,#1E88E5)",
    path: "/quiz/shapes",
  },
  {
    id: 11,
    name: "Measurement",
    icon: "📏",
    color: "linear-gradient(135deg,#66BB6A,#43A047)",
    path: "/quiz/measure",
  },
  {
    id: 12,
    name: "Time",
    icon: "⏰",
    color: "linear-gradient(135deg,#FFA726,#FB8C00)",
    path: "/quiz/time",
  },
  {
    id: 13,
    name: "Fraction",
    icon: "🍕",
    color: "linear-gradient(135deg,#AB47BC,#8E24AA)",
    path: "/quiz/fraction",
  },

];
const categories5 = [
  
  {
    id: 14,
    name: "Flair AI Robot",
    icon: "🤖",
    color: "linear-gradient(135deg,#FF4D8D,#D81B60)",
    path: "/quiz/robot",
  },
    {
    id: 15,
    name: "Multiples & Factors",
    icon: "🧮",
      color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplefactors",
  },
   {
    id: 2,
    name: "Large Numbers",
    icon: "🔢",
    color: "linear-gradient(135deg,#9C27B0,#673AB7)",
    path: "/quiz/placevalue",
  },
   {
    id: 2,
    name: "Decimals",
    icon: "🔢",
    color: "linear-gradient(135deg,#4FACFE,#00F2FE)",
    path: "/quiz/decimal",
  },
  {
    id: 1,
    name: "Addition & Subtraction",
    icon: "➕",
    color: "linear-gradient(135deg,#22C55E,#16A34A)",
    path: "/quiz/math",
  },
 
  {
    id: 3,
    name: "Sorting",
    icon: "🧩",
    color: "linear-gradient(135deg,#26C6DA,#00ACC1)",
    path: "/quiz/sorting",
  },
  {
    id: 4,
    name: "Multiplication",
    icon: "✖️",
    color: "linear-gradient(135deg,#FF8A00,#FF6F00)",
    path: "/quiz/multiplication",
  },
  {
    id: 5,
    name: "Division",
    icon: "➗",
    color: "linear-gradient(135deg,#F06292,#E91E63)",
    path: "/quiz/division",
  },
   {
    id: 6,
    name: "Puzzles",
    icon: "🧠",
    color: "linear-gradient(135deg,#9C27B0,#673AB7)",
    path: "/quiz/puzzles",
  },
   {
    id: 7,
    name: "Symmetry & Pattern",
    icon: "🦋",
    color: "linear-gradient(135deg,#7C4DFF,#5E35B1)",
    path: "/quiz/logic",
  },
  {
    id: 8,
    name: "Sudoku",
    icon: "🔢",
    color: "linear-gradient(135deg,#00BCD4,#0097A7)",
    path: "/quiz/sudoku",
  },

  {
    id: 9,
    name: "Money",
    icon: "💰",
    color: "linear-gradient(135deg,#FFD54F,#FFB300)",
    path: "/quiz/money",
  },
  {
    id: 10,
    name: "Geometry & Shapes",
    icon: "📐",
    color: "linear-gradient(135deg,#42A5F5,#1E88E5)",
    path: "/quiz/shapes",
  },
  {
    id: 11,
    name: "Measurement",
    icon: "📏",
    color: "linear-gradient(135deg,#66BB6A,#43A047)",
    path: "/quiz/measure",
  },
  {
    id: 12,
    name: "Time",
    icon: "⏰",
    color: "linear-gradient(135deg,#FFA726,#FB8C00)",
    path: "/quiz/time",
  },
  {
    id: 13,
    name: "Fraction",
    icon: "🍕",
    color: "linear-gradient(135deg,#AB47BC,#8E24AA)",
    path: "/quiz/fraction",
  },

];
const QuizCategories = ({ setUser }) => {
  const navigate = useNavigate();
  const [level, setLevel] = useState(null);
 const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  useEffect(() => {
    const fetchUser = async () => {
        const token = localStorage.getItem("token");

   // if (!token) return; // ⛔ stop auto-login
      try {
        const res = await api.get("/auth/getMe");
        setUser(res.data);
      } catch (err) {
        console.error("Failed to fetch user:", err);
      }
    };
    fetchUser();
  }, []);
        const renderCategories = (list) => (
  <Row gutter={[16, 16]} justify="center">
    {list.map((cat) => (
      <Col key={cat.id} xs={24} sm={12} md={8}>
        <QuizCategoryCard
          cat={cat}
          onClick={() => navigate(`${cat.path}?level=${level}`)}
        />
      </Col>
    ))}
  </Row>
);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        // backgroundColor: "#315cb9",
        background: "linear-gradient(135deg, #821f82  0%,  #5b84de 60%,#315cb9 100%)",
  boxShadow:
    "0 10px 30px rgba(49, 92, 185, 0.35), 0 2px 8px rgba(255,255,255,0.15) inset",
  borderRadius: "0px",
        padding: 10,
      }}
    >
   
      <Card
        title={
          <div
            style={{

              fontSize: windowWidth<420?"1.5rem":"2rem",
              fontWeight: "bold",
              color: "#ff6b00",
              
              textAlign: "center",
              padding: 10,
            }}
          >
            🧠 {level ? "Select Quiz Category" : "Choose Level"}
          </div>
        }
        style={{
          width: "100%",
          maxWidth: 850, // responsive max width
          textAlign: "center",
          borderRadius: 20,
          padding: 0,
        }}
      >
        {/* STEP 1 — Choose Level */}
        
      
  {!level && (
  <Row gutter={[20, 20]} justify="center">
    
    {/* Select By Topics */}
    <Col xs={24} md={10}>
      <div
        style={{
          background:
            "linear-gradient(135deg, #0c83eb 0%, #0a8288 100%)",
          borderRadius: 24,
          padding: 24,
          height: 320,
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: 700,
            color: "#fff",
            paddingTop:25,
            marginBottom: 40,
            textAlign: "center",
          }}
        >
          📚 Select By Topics 
          <hr></hr>
        </div>

        <Button
          block
          size="large"
          style={{
            height: 80,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            marginBottom: 12,
          }}
          onClick={() => setLevel("kindergarten")}
        >
          Kindergarten
        </Button>

        <Button
          block
          size="large"
          style={{
            height: 80,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
          }}
          onClick={() => setLevel("primary")}
        >
          Primary Level
        </Button>
      </div>
    </Col>

    {/* Olympiad Worksheets */}
    <Col xs={24} md={7}>
      <div
        style={{
       background: "linear-gradient(135deg, #FFA726 0%, #FF7043 35%, #F4511E 70%, #D32F2F 100%)",
         //  background: "linear-gradient(135deg, #FF8A00 0%, #e73538 100%)",
          // background: "linear-gradient(135deg, #e9da06 0%, #A93226 100%)",
          borderRadius: 24,
          padding: 24,
          height: 320,
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
            marginBottom: 20,
          }}
        >
          🏆 Olympiad Worksheets <hr></hr>
        </div>

        <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#fff",
            // color: "#e91518",
             color:
    "linear-gradient(180deg, #ffb0b2 0%, #ff6f72 8%, #ff4044 20%, #e91518 50%, #b60d10 80%, #850709 100%)",
            fontWeight: "bold",
            fontSize: "8.1rem",
          }}
          onClick={() => setLevel("olympiad")}
        >
        📝
        </Button>
      </div>
    </Col>

    {/* Select By Grade */}
    <Col xs={24} md={7}>
      <div
        style={{
          background:
            "linear-gradient(135deg, #c38cd1 0%, #455fdf 100%)",
          borderRadius: 24,
          padding: 24,
          height: 320,
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
            marginBottom: 20,
          }}
        >
          🎓 Select By Grade <hr></hr>
        </div>

         <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            fontSize: "1.1rem",
              padding: 0,
               marginBottom:5
          }}
          onClick={() => setLevel("gradewise1")}
        >
          Grade 1
        </Button>
         <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            fontSize: "1.1rem",
              padding: 0,
               marginBottom:5
          }}
          onClick={() => setLevel("gradewise2")}
        >
          Grade 2
        </Button>
 <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            fontSize: "1.1rem",
              padding: 0,
               marginBottom:5
          }}
          onClick={() => setLevel("gradewise3")}
        >
          Grade 3
        </Button>
        <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            fontSize: "1.1rem",
              padding: 0,
              marginBottom:5
          }}
          onClick={() => setLevel("gradewise4")}
        >
          Grade 4
        </Button>
        <Button
          block
          size="large"
          style={{
            flex: 1,
            borderRadius: 15,
            background: "#ffbf00",
            color: "#4d3300",
            fontWeight: "bold",
            fontSize: "1.1rem",
              padding: 0,
              marginBottom:20
          }}
          onClick={() => setLevel("gradewise4")}
        >
          Grade 5
        </Button>
       
      </div>
    </Col>

  </Row>
)}

        {/* STEP 2 — Show Quiz Options */}
        {level && (
          <>
            <Button
              onClick={() => setLevel(null)}
              style={{
              
                marginBottom: 20,
                fontSize: 16,
                borderRadius: 10,
              }}
            >
              ⬅ Back
            </Button>

{level === "kindergarten" && renderCategories(categories)}

    {level === "primary" && renderCategories(categories5)}

  {["gradewise1", "gradewise2", "gradewise3"].includes(level) &&
  renderCategories(categories4)}
  {[ "gradewise5", "gradewise4"].includes(level) &&
  renderCategories(categories5)}

    {level === "olympiad" && renderCategories(categories3)}

 


          </>
        )}
      </Card>
    </div>
  );
};

export default QuizCategories;

